export type CheckableColor = { label: string; isDisabled: boolean; isChecked: boolean; biId?: string };

export class CheckboxHarnessController {
  private colors: CheckableColor[];
  public isChecked = false;

  constructor() {
    this.colors = [
      { label: "Should I be red?", isDisabled: false, isChecked: false, biId: "checkbox group harness 1" },
      { label: "Should I be green?", isDisabled: false, isChecked: false },
      { label: "Should I be blue?", isDisabled: true, isChecked: true, biId: "checkbox group harness 3" }
    ];
  }

  public onCheckboxChanged(value: boolean, item: CheckableColor) {
    console.info(`Checkbox ${item.label} was ${value ? "checked" : "unchecked"}`);
  }
}
